import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

/**
 * BackButton component - displays a back navigation button inside pages
 *
 * Usage:
 *   <BackButton />                    // Goes back in history
 *   <BackButton to="/products" />     // Goes to specific path
 *   <BackButton label="Back to List" /> // Custom label
 */
const BackButton = ({ to, label = 'Back', style = {}, ...props }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <Button
      type="link"
      icon={<ArrowLeftOutlined />}
      onClick={handleClick}
      style={{
        padding: '4px 0',
        marginBottom: '16px',
        color: '#5A6B5C',
        fontWeight: 500,
        ...style
      }}
      {...props}
    >
      {label}
    </Button>
  );
};

export default BackButton;
